export default __webpack_public_path__ + "static/media/img11.c91fd8c0.png";